export default __webpack_public_path__ + "static/media/ic_sent_alert.6bc12615.svg";